/**
 * The scheme ID URI for thumbnail tiles in DASH.
 *
 * @public
 */
export const THUMBNAIL_TILE_SCHEME_ID_URI = 'http://dashif.org/guidelines/thumbnail_tile'
